export default function profileFeed() {
  return {
    _id: false,
    type: 'droplet.profileFeed',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    sort: 'newest',
    filters: [],
    match: 'all',
    itemCount: 3,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/profile-feed/droplet.schema.js